module.exports = __webpack_public_path__ + "img/passesd_courses.fc76e31a.svg";